import { getTeams } from './teams.js';
import { canonicalTeamSlug } from '../data/teamIdentity.js';

export function applyCurrentRecords(games, teams, date = '') {
  const bySlug = new Map(teams.map((team) => [canonicalTeamSlug(team.slug || team.name), team]));
  return games.map((game) => {
    const next = { ...game };
    for (const side of ['away', 'home']) {
      const current = bySlug.get(canonicalTeamSlug(game[side]?.slug || game[side]?.name));
      const throughDate = current?.finalRecord?.throughDate;
      const gameDate = String(game.date || game.scheduleDate || game.dateKey || date).slice(0, 10);
      if (!current?.record || !throughDate || (game.status === 'final' && (!gameDate || throughDate < gameDate))) continue;
      if (game[side]?.recordThroughDate > throughDate) continue;
      next[side] = { ...game[side], record: current.record, recordThroughDate: throughDate,
        recordSource: current.finalRecord.sourceType || 'current-team-directory', finalRecord: current.finalRecord };
    }
    return next;
  });
}
export async function getCurrentRecordSnapshots(games, date, signal) {
  if (!String(date).startsWith('2026-') || !games.length) return [];
  const directory = await getTeams({ season: 2026, signal });
  return applyCurrentRecords(games, directory.teams || [], date);
}
